// extracted by mini-css-extract-plugin
export default {"main":"styles_main__nGW77","main2":"styles_main2__mw73p","arrow":"styles_arrow__thTVU"};